<script setup>
defineProps({
  resident: {
    type: Object,
    required: true,
  },
});

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};

const paymentStatusText = (status) => {
  const map = {
    paid: "ชำระแล้ว",
    partial: "ชำระบางส่วน",
    overdue: "ค้างชำระ",
    pending: "รอชำระ",
  };
  return map[status] || status;
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปการเงิน</h5>
          <div class="text-muted small">สถานะค่าส่วนกลางและยอดค้างชำระ</div>
        </div>
        <div class="icon-box bg-warning-subtle text-warning">
          <i class="bi bi-wallet2"></i>
        </div>
      </div>

      <div class="summary-box bg-light rounded-4 p-3 mb-3">
        <div class="text-muted small mb-1">สถานะการชำระปัจจุบัน</div>
        <div class="fw-bold fs-5">
          {{ paymentStatusText(resident.paymentStatus) }}
        </div>
      </div>

      <div
        class="summary-box rounded-4 p-3 mb-4"
        :class="
          resident.outstanding > 0
            ? 'bg-danger bg-opacity-10'
            : 'bg-success bg-opacity-10'
        "
      >
        <div class="text-muted small mb-1">ยอดค้างชำระรวม</div>
        <div
          class="fw-bold fs-4"
          :class="resident.outstanding > 0 ? 'text-danger' : 'text-success'"
        >
          {{ formatCurrency(resident.outstanding) }}
        </div>
      </div>

      <div class="vstack gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ยูนิตที่เกี่ยวข้อง</span>
          <span class="fw-semibold">{{ resident.unitCode }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">อาคาร / โซน</span>
          <span class="fw-semibold"
            >{{ resident.building }} / {{ resident.zone }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.icon-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
</style>
